module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }